export default __webpack_public_path__ + "static/media/NubCon.968165b4.png";